function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "noun_papers_1629235",
  transform: "translate(365 242.8)"
}, React.createElement("g", {
  id: "Group_11",
  "data-name": "Group 11",
  transform: "translate(-381.7 -248)"
}, React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M0,0H11L5.826,6.852,0,14Z",
  transform: "translate(63.7 74.2)",
  fill: "#92b8eb"
}), React.createElement("path", {
  id: "Path_19",
  "data-name": "Path 19",
  d: "M28.1,64H47.4a1,1,0,0,0,0-2H28.1a1,1,0,0,0-1,1A.945.945,0,0,0,28.1,64Z",
  fill: "#424b58"
}), React.createElement("path", {
  id: "Path_20",
  "data-name": "Path 20",
  d: "M51.3,78.8h-9a1,1,0,0,0,0,2h9a1,1,0,0,0,1-1A.945.945,0,0,0,51.3,78.8Z",
  fill: "#424b58"
}), React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M28.1,20.2H39.7a1,1,0,0,0,1-1,1.075,1.075,0,0,0-1-1H28.1a1,1,0,0,0,0,2Z",
  fill: "#424b58"
}), React.createElement("path", {
  id: "Path_22",
  "data-name": "Path 22",
  d: "M28.1,31.8H65.5a1,1,0,0,0,0-2H28.1a1,1,0,0,0,0,2Z",
  fill: "#424b58"
}), React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M28.1,38.2H65.5a1,1,0,0,0,0-2H28.1a1,1,0,0,0-1,1A.945.945,0,0,0,28.1,38.2Z",
  fill: "#424b58"
}), React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M28.1,44.7H65.5a1,1,0,0,0,1-1,1.075,1.075,0,0,0-1-1H28.1a1,1,0,1,0,0,2Z",
  fill: "#424b58"
}), React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M28.1,51.1H65.5a1,1,0,0,0,1-1,1.075,1.075,0,0,0-1-1H28.1a1,1,0,0,0,0,2Z",
  fill: "#424b58"
}), React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M28.1,57.6H65.5a1,1,0,0,0,1-1,1.075,1.075,0,0,0-1-1H28.1a1,1,0,0,0,0,2Z",
  fill: "#424b58"
}), React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M81.6,11.7H80V10.1a1.685,1.685,0,0,0-1.7-1.7H76.7V6.9A1.685,1.685,0,0,0,75,5.2H18.4a1.685,1.685,0,0,0-1.7,1.7v80a1.685,1.685,0,0,0,1.7,1.7H20v1.6a1.685,1.685,0,0,0,1.7,1.7h1.6v1.6A1.685,1.685,0,0,0,25,95.2H81.8a1.685,1.685,0,0,0,1.7-1.7v-80A2.017,2.017,0,0,0,81.6,11.7ZM74.8,73.6H63.5a1.685,1.685,0,0,0-1.7,1.7V86.5h-43V7.3h56Zm-1.5,2.1-9.4,9.4V75.7ZM62.9,88.5a.908.908,0,0,0,.7-.3L76.5,75.3a.908.908,0,0,0,.3-.7V10.5H78V89.7H22V88.5ZM25.2,91.8H78.4a1.685,1.685,0,0,0,1.7-1.7V13.7h1.2V93h-56V91.8Z",
  fill: "#424b58"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 66.8,
    height: 90,
    viewBox: "0 0 66.8 90"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/papers.0d5c0aa2.svg";
export { SvgComponent as ReactComponent };